export const UserIdIcon = () => (
  <svg fill="none" height="86" viewBox="0 0 79 86" width="79" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_567_3598)">
      <path
        d="M22.8384 33.7929V14.1395H69.1202L76.5253 21.5098V84.1574H22.8384V79.7053"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M56.161 39.9355H4.32539C3.30296 39.9355 2.47412 40.7605 2.47412 41.7781V73.1019C2.47412 74.1196 3.30296 74.9445 4.32539 74.9445H56.161C57.1834 74.9445 58.0123 74.1196 58.0123 73.1019V41.7781C58.0123 40.7605 57.1834 39.9355 56.161 39.9355Z"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M19.1358 47.2299C22.202 47.2299 24.6897 49.5538 24.6897 52.419V55.0147C24.6897 57.8823 22.202 60.2039 19.1358 60.2039C16.0697 60.2039 13.582 57.88 13.582 55.0147V52.419C13.582 49.5515 16.0697 47.2299 19.1358 47.2299Z"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M9.87939 67.5742V65.7317C9.87939 62.8641 14.0239 60.2039 19.1358 60.2039C24.2476 60.2039 28.3921 62.8641 28.3921 65.7317V67.5742"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M35.7974 49.1484H48.7563"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M35.7974 56.5187H48.7563"
        stroke="#01E47F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path d="M35.7974 63.889H45.0537" stroke="#01E47F" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
    </g>
    <defs>
      <clipPath id="clip0_567_3598">
        <rect fill="white" height="86" transform="translate(0.623047)" width="77.7534" />
      </clipPath>
    </defs>
  </svg>
);
